"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutReleasePreviousOpenOverview_1 = require("../../model/sellout/SelloutReleasePreviousOpenOverview");

var SelloutReleasePreviousOpenOverviewConverter_1 = require("./SelloutReleasePreviousOpenOverviewConverter");
/**
 * @author Jan Prokop
 */


var SelloutReleasePreviousOpenOverviewConverterImpl =
/*#__PURE__*/
function (_SelloutReleasePrevio) {
  _inherits(SelloutReleasePreviousOpenOverviewConverterImpl, _SelloutReleasePrevio);

  function SelloutReleasePreviousOpenOverviewConverterImpl() {
    _classCallCheck(this, SelloutReleasePreviousOpenOverviewConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleasePreviousOpenOverviewConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutReleasePreviousOpenOverviewConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutReleasePreviousOpenOverview_1.SelloutReleasePreviousOpenOverview(SelloutReleasePreviousOpenOverview_1.SelloutReleasePreviousOpenOverview.schema.priceValidityStartDate.valueOfField(source), SelloutReleasePreviousOpenOverview_1.SelloutReleasePreviousOpenOverview.schema.endDate.valueOfField(source), source.discountPercent != null ? conversions.toBigNumber(source.discountPercent) : null, source.minPriceChangeInPercent != null ? conversions.toBigNumber(source.minPriceChangeInPercent) : null, source.maxPriceChangeInPercent != null ? conversions.toBigNumber(source.maxPriceChangeInPercent) : null, source.minMarginChangeInPercent != null ? conversions.toBigNumber(source.minMarginChangeInPercent) : null);
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        priceValidityStartDate: conversions.fromDate(source.priceValidityStartDate),
        endDate: source.endDate && conversions.fromDate(source.endDate),
        discountPercent: source.discountPercent && conversions.fromBigNumber(source.discountPercent),
        minPriceChangeInPercent: source.minPriceChangeInPercent && conversions.fromBigNumber(source.minPriceChangeInPercent),
        maxPriceChangeInPercent: source.maxPriceChangeInPercent && conversions.fromBigNumber(source.maxPriceChangeInPercent),
        minMarginChangeInPercent: source.minMarginChangeInPercent && conversions.fromBigNumber(source.minMarginChangeInPercent)
      };
    }
  }]);

  return SelloutReleasePreviousOpenOverviewConverterImpl;
}(SelloutReleasePreviousOpenOverviewConverter_1.SelloutReleasePreviousOpenOverviewConverter);

exports.SelloutReleasePreviousOpenOverviewConverterImpl = SelloutReleasePreviousOpenOverviewConverterImpl;